import { PlaylistType } from '@/enums';
import { PlaylistDetails } from '@/pages/Playlists/PlaylistDetails';

export const DigitalSignagePlaylistDetails = () => {
  return <PlaylistDetails playlistType={PlaylistType.MIX} />;
};
